<template>
  <div>
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel class="chart-widget" :title="$t('graficosSaude.filaHistoricoUltimosMeses')"
          :tooltipOptions="tooltipLineHistoricoUltimosMeses" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">

          <multiselect v-model="value" label="subprefeitura" track-by="subprefeitura" :options="historicoSubprefeituras" :multiple="true" :taggable="true" @input="populateLineHistorico">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen">
                {{ values.length }} subprefeituras selecionadas
              </span>
            </template>
          </multiselect>

          <sp360-chart  ref="chartHistoricoFilaSubprefeitura" v-bind:data="dataLineHistoricoUltimosMeses" :options="optionsLineHistoricoUltimosMeses"
            type="line" />

        </sp-360-panel>
      </div>
    </div>
    <div class="row topCardGrid" v-if="false">
        <sp-card/>
        <sp-card/>
        <sp-card/>
        <sp-card/>
    </div>
    <sp-360-panel :title="tabela.titulo" :tooltipOptions="tabela.topTooltipOptions" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
        <sp360-chart :data="filaSaudeChart" type="vertical-bar" :options="filaSaudeChartOptions" />
        <div class="flex-box">
            <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="false"></sp-map>
            <sp360-data-table id="tabelaFilaSaude" ref="filaSaude"
                :apiMode="false"
                :data="tabela.tableData.data"
                :fields="tabela.tableFields"
                :sortFunctions="tabela.sortFunctions"
                :perPage="tabela.itemsPerPage"
            />
        </div>
    </sp-360-panel>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import AutoUpdate from '@/services/AutoUpdate'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Multiselect from 'vue-multiselect'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import * as d3 from 'd3'

export default {
  name: 'demanda-regionalizada',
  components: { SpMap, Multiselect, SpCard, Sp360Chart, Sp360Panel, Sp360DataTable },

  data () {
    return {
      dataRef: '',
      fonte: '',
      dados: [],
      set: [],
      tooltip: { placement: 'bottom', content: 'empty' },
      tabela: {
        titulo: this.$t('graficosSaude.porSubprefeitura.subprefeitura'),
        tableData: { 'data': [] },
        tableFields: [
          {
            name: 'subprefeitura',
            sortField: 'subprefeitura',
            // title: 'Subprefeitura',
            title: this.$t('graficosSaude.porSubprefeitura.subprefeitura'),
            width: '20%',
          },
          {
            name: 'total',
            sortField: 'total',
            // title: 'Total',
            title: this.$t('graficosSaude.porSubprefeitura.total'),
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'procedimentos_clinicos',
            sortField: 'procedimentos_clinicos',
            // title: 'Procedimentos clínicos',
            title: this.$t('graficosSaude.porSubprefeitura.procedimentosClinicos'),
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          {
            name: 'procedimentos_com_finalidade_diagnostica',
            sortField: 'procedimentos_com_finalidade_diagnostica',
            // title: 'Procedimentos com finalidade diagnóstica',
            title: this.$t('graficosSaude.porSubprefeitura.ProcedimentosDiagnostico'),
            callback: MethGlob.thousandSeparator,
            width: '12%',
          },
          // {
          //     name:'orteses_proteses_e_materiais_especiais',
          //     sortField:'orteses_proteses_e_materiais_especiais',
          //     title: 'Órteses, próteses e materiais especiais',
          //      callback: MethGlob.thousandSeparator,
          //     width:'12%'
          // },
          // {
          //     name:'procedimentos_cirurgicos',
          //     sortField:'procedimentos_cirurgicos',
          //     title: 'Procedimentos cirúrgicos',
          //      callback: MethGlob.thousandSeparator,
          //     width:'12%'
          // },
        ],
        sortFunctions: {
          'subprefeitura': MethGlob.ordenaTabela,
          'total': MethGlob.ordenaTabelaParseInt,
          'procedimentos_clinicos': MethGlob.ordenaTabelaParseInt,
          'procedimentos_com_finalidade_diagnostica': MethGlob.ordenaTabelaParseInt,
          'orteses_proteses_e_materiais_especiais': MethGlob.ordenaTabelaParseInt,
          'procedimentos_cirurgicos': MethGlob.ordenaTabelaParseInt,
        },
        topTooltipOptions: {
          content: this.$t('graficosSaude.tooltipFilaProcedimentosPorRegiao'), placement: 'bottom', classes: 'va-tooltip tooltip vuestic-tooltip customTooltip',
        },
        itemsPerPage: 12, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
      },
      filaSaudeChartOptions: {},
      filaSaudeChart: {},
      tooltipLineHistoricoUltimosMeses: {
        content: this.$t('graficosSaude.tooltipHistoricoUltimosMeses'),
        placement: 'bottom',
      },
      dataLineHistoricoUltimosMeses: {},
      optionsLineHistoricoUltimosMeses: {},
      value: [],
      historicoSubprefeituras: [],
      numeroSubsIniciais: 5,
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('saude/buscarFilaDeExamePorTipoProcedimentoPorRegiao', { tipoProcedimento: 'TODOS' }),
      this.$store.dispatch('saude/buscarFilaDeExameHistoricoRegiao', { ultimosMeses: 13 }),
    ]).then(respostas => {
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      let tData = this.popularTabela(respostas[0].data.data)
      tData.shift()
      this.$set(this.tabela.tableData, 'data', tData)
      this.pintarRegiao(this.set)

      this.$refs.mapa.setLegenda(tData[tData.length - 1].total, tData[0].total, this.$t('graficosSaude.textoEixoLegenda.demandaRegiaoProcedimentos'), 6)
      this.criarLegenda()

      this.filaSaudeChart = this.fillDataSet({ labels: [], datasets: [] }, _.orderBy(this.set, 'total', 'desc'), 'total',
        'subprefeitura', 'Total de Procedimentos', _.shuffle(CorUtils.getVetorCoresPorTom('claro').concat(CorUtils.getVetorCoresPorTom('medio'))))
      this.filaSaudeChartOptions = this.getchartOptions('Subprefeitura  ', 'Numero de Procedimentos', this.filaSaudeChart)

      this.historicoSubprefeituras = this.ordenaMaioresFilasHistorico(respostas[1].data.data)
      this.value = this.historicoSubprefeituras.slice(0, this.numeroSubsIniciais)
      let lineHistoricoUltimosMeses = this.populateLineHistorico()
      this.dataLineHistoricoUltimosMeses = lineHistoricoUltimosMeses.chartData
      this.optionsLineHistoricoUltimosMeses = lineHistoricoUltimosMeses.options
    })
  },

  methods: {
    ordenaMaioresFilasHistorico (subs) {
      return _.orderBy(subs, [sub => {
        let sum = _.reduce(sub.lista_historico, (sum, mes) => {
          return sum + mes.total
        }, 0)

        return sum / sub.lista_historico.length
      }], ['desc'])
    },

    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub != id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
      } else {
        this.$refs.mapa.limparClick(id)
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.munAtual = this.$t('graficosEducacao.geral')
      }
    },

    popularTabela (dados) {
      dados.forEach(e => {
        let datatable = {
          id_subprefeitura: 0,
          subprefeitura: '',
          total: 0,
          procedimentos_clinicos: 0,
          procedimentos_com_finalidade_diagnostica: 0,
          orteses_proteses_e_materiais_especiais: 0,
          procedimentos_cirurgicos: 0,
        }
        datatable.id_subprefeitura = e.id_subprefeitura
        datatable.subprefeitura = e.subprefeitura
        datatable.total = e.total
        e.lista_tipos_procedimentos.forEach(p => {
          if (p.tipo_procedimento === 'Procedimentos clínicos') {
            datatable.procedimentos_clinicos = p.total
          } else if (p.tipo_procedimento === 'Procedimentos com finalidade diagnóstica') {
            datatable.procedimentos_com_finalidade_diagnostica = p.total
          } else if (p.tipo_procedimento === 'Órteses, próteses e materiais especiais') {
            datatable.orteses_proteses_e_materiais_especiais = p.total
          } else if (p.tipo_procedimento === 'Procedimentos cirúrgicos') {
            datatable.procedimentos_cirurgicos = p.total
          }
        })
        this.set.push(datatable)
      })
      return _.orderBy(this.set, 'total', 'desc')
    },

    criarLegenda () {
      let c = CorUtils.getCoresMapa()
      this.$refs.mapa.definirLegenda(
        [c.claro, c.escuro],
        [this.$t('graficosSaude.legenda.demanda'),
          this.$t('graficosSaude.legenda.baixa'),
          this.$t('graficosSaude.legenda.media'),
          this.$t('graficosSaude.legenda.alta')]
      )
    },

    // Pinta as areas do mapa de acorco com um valor arbitrario
    // TODO : Delimitar uma formula para o farol.
    pintarRegiao (dados) {
      let c = CorUtils.getCoresMapa()
      dados.shift()
      dados = _.orderBy(dados, ['total'], ['asc'])
      let colorScale = d3.scaleLinear()
        .domain([_.first(dados).total, _.last(dados).total])
        .range([c.claro, c.escuro])

      dados.forEach((element) => {
        let id = 'sub' + element.id_subprefeitura
        this.$refs.mapa.pintarRegiao(id, colorScale(element.total))
      })
    },

    populateLineHistorico () {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = [...CorUtils.getVetorCoresPorTom('claro'), ...CorUtils.getVetorCoresPorTom('claro')]
      let Labels = ''
      let dados = this.value

      let totalLabel = this.$t('graficosSaude.labelHistoricoTotal') // 'Total de Procedimentos'

      // dados[totalLabel] = this.processaHistoricoTotal(d);

      _.forEach(dados, reg => {
        // inverte a array pois a query traz ela em ordem inversa
        let historico = _.reverse(reg.lista_historico)

        Labels = _.map(historico, (r) => {
          return MethGlob.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
        })

        let fila = _.map(historico, (n) => {
          return n.total
        })

        let corDataset = cores[reg.id_subprefeitura]

        let datasetHistorico = {
          label: reg.subprefeitura,
          fill: false,
          backgroundColor: corDataset,
          borderColor: corDataset,
          data: fila,
          yAxisID: 'y-axis-1',

        }

        datasets.push(datasetHistorico)
      })

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptionsLine('graficosSaude.lineFilaHistoricoEixoX', 'graficosSaude.lineFilaHistoricoEixoY', false, true)

      this.dataLineHistoricoUltimosMeses = chartData
      this.optionsLineHistoricoUltimosMeses = options

      this.$refs.chartHistoricoFilaSubprefeitura.$refs.chart.renderChart(chartData, options)

      return {
        chartData,
        options,
      }
    },

    getchartOptions (xAxixLabel, yAxixLabel, chartData) {
      return {
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 50,
            bottom: 5,
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              if (tooltipItems[0].datasetIndex === _.findIndex(chartData.datasets, (o) => o.yAxisID === 'LineAxis')) {
                return 'Acumulado'
              }
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }

              return title
            },
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].yAxisID == 'LineAxis') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return currentValue.toFixed(2) + '%'
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + MethGlob.thousandSeparator(currentValue)
              }
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              id: 'BarAxis',
              position: 'left',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            },
            {
              id: 'LineAxis',
              position: 'right',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Percentual de Cada sub em relação ao total',
              },
              ticks: {
                callback: function (value, index, values) {
                  return value + '%'
                },
              },
            }] },
      }
    },

    getOptionsLine (legendaX, legendaY, percentual = true, milhar = false) {
      return {
        tooltips: {
          intersect: true,
          callbacks: MethGlob.percentualLabelCallback(false, true, 'line'),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
              beginAtZero: true,
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }],
        },
      }
    },

    fillDataSet (barchartData, dados, atrbDados, atrbLegenda, datasetLabel, backgroundColor) {
      let palette = this.$store.getters.palette

      let dataset = {
        backgroundColor: backgroundColor,
        borderColor: palette.transparent,
        data: [],
        yAxisID: 'BarAxis',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          font: {
            weight: 'bold',
          },
          anchor: 'end',
          rotation: -90,
          align: 'end',
        },
        categoryPercentage: 0.2,
        barPercentage: 1.0,
      }

      let datasetLine = {
        backgroundColor: CorUtils.setAlpha(CorUtils.getCorPorNomeSp360('cinza-medio'), 40),
        borderColor: CorUtils.getCorPorNomeSp360('amarelo-bistre-claro'),
        type: 'line',
        yAxisID: 'LineAxis',
        data: [],
        datalabels: {
          display: false,
        },
      }

      let aux = 0
      let total = 0

      dados.forEach(element => {
        if (element) {
          barchartData.labels.push(element[atrbLegenda])
          dataset.data.push(element[atrbDados])
          dataset.label = datasetLabel
          total += element[atrbDados]
        }
      })

      dados.forEach(element => {
        aux += ((element[atrbDados] / total) * 100)
        datasetLine.data.push(aux)
      })

      barchartData.datasets.push(datasetLine) // HardCoded <- pode ser afetado pela ordem de definição dos datasets. Recomanda-se não mudar
      barchartData.datasets.push(dataset)
      return barchartData
    },

  },
}
</script>

<style lang="scss" scoped>
  .va-chart {
    max-height: 25rem
  }
    .flex-box{
        display: flex;
    }
    #mapaSP{
        width: 25%;
    }
    #tabelaFilaSaude{
        width: 75%;
        height: auto
    }
</style>

<style lang="scss">
